module.exports = __webpack_public_path__ + "static/img/PR.264f5f55.svg";